import { createSlice } from '@reduxjs/toolkit';
import { addAsyncCasesNew } from 'shared/utils/redux';

import { fetchTemplateLibrary, fetchTemplatePreview } from './asyncActions';
import { CreateFromTemplateState, STORE_NAME } from './initialState';

export const createFromTemplateSlice = createSlice({
  name: STORE_NAME,
  initialState: CreateFromTemplateState.INITIAL_DOMAIN,
  reducers: {
    clearTemplateLibrary: (state) => {
      state.libraryResource = CreateFromTemplateState.INITIAL_DOMAIN.libraryResource;
    },
    clearTemplatePreview: (state) => {
      state.previewResource = CreateFromTemplateState.INITIAL_DOMAIN.previewResource;
    },
  },
  extraReducers: (builder) => {
    addAsyncCasesNew(builder, fetchTemplateLibrary, (state, action) => {
      state.libraryResource = action.payload;
    });
    addAsyncCasesNew(builder, fetchTemplatePreview, (state, action) => {
      state.previewResource = action.payload;
    });
  },
});

export const { clearTemplateLibrary, clearTemplatePreview } = createFromTemplateSlice.actions;
